interface HeroImageProps {
  src: string;
  alt: string;
}

export const HeroImage = ({ src, alt }: HeroImageProps) => {
  return (
    <div className="l-hero">
      <img className="l-hero__img" src={src} alt={alt} />
    </div>
  );
};
